import styles from './GameRow.module.css';
import { formatRuDate } from '@/shared/lib/date/formatRuDate.js';
import transleetSessionFormat from "@/shared/lib/sessionFormat/transleetSessionFormat.js";

export default function GameRow({ gameNumber, game }) {
    return (
        <div className={styles.row}>
            <div className={styles.dateBlock}>
                <div className={styles.date}>{formatRuDate(game.playedAt)}</div>
                <div className={styles.number}>( {String(gameNumber).padStart(2, '0')} )</div>
            </div>
            <div className={styles.title}>{game.gameTitle}</div>
            <div className={styles.info}>
                <p className="body"><span>Система</span> {game.gameSystemName} | {transleetSessionFormat(game.sessionFormatName)}</p>
                <hr className={styles.hr}/>
                <p className="body"><span>Мастер</span> {game.masterName}</p>
            </div>
        </div>
    );
}
